import WidgetModel from '../../shared/classes/widget-model';

/**
 * @class Widget
 */
export default class Widget extends WidgetModel {
	constructor (model) {
		// I wanna be a
		super(model);
		this.createdBy = model.createdBy;
	}

	get expandIcon () {
		return this.node.querySelector('button.expand.icon');
	}

	get minimizeIcon () {
		return this.node.querySelector('button.minimize.icon');
	}

	get minimized () {
		return window.localStorage.getItem(this.storageKey) === 'true';
	}

	get node () {
		return document.getElementById(this.nodeId);
	}

	get nodeId () {
		return `edlio-page-${this.id}`;
	}

	get storageKey () {
		return `minimize_${this.nodeId}`;
	}

	get storageKeyExists () {
		return window.localStorage.getItem(this.storageKey) !== null;
	}

	addStyle (property, value) {
		this.node.style = {...this.node.style, [property]: value};
	}

	removeStyle (property) {
		this.node.style.removeProperty(property);
	}

	createStorageKey () {
		window.localStorage.setItem(this.storageKey, 'false');
	}

	expand (evt) {
		window.localStorage.setItem(this.storageKey, 'false');

		this.node.classList.remove('minimized');
		this.node.classList.add('transition-in');

		setTimeout(() => {
			this.node.classList.remove('transition-in');
		}, 236);
	}

	initialize () {
		if (!this.storageKeyExists) {
			this.createStorageKey();
		}

		if (this.minimized) {
			this.node.classList.add('minimized');
		}

		this.minimizeIcon.addEventListener('click', evt => {
			evt.preventDefault();
			this.minimize();
		});

		this.expandIcon.addEventListener('click', evt => {
			evt.preventDefault();
			this.expand();
		});
	}

	minimize (evt) {
		window.localStorage.setItem(this.storageKey, 'true');

		this.node.classList.add('transition-out');

		setTimeout(() => {
			this.node.classList.add('minimized');
			this.node.classList.remove('transition-out');
		}, 236);
	}

	render () {
		document.body.insertAdjacentHTML('beforeend', this.template);
		this.initialize();

		if (this.node.style.position === 'absolute') {
			this.node.style.zIndex = '997';
		}
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/stickybins/scripts/public/classes/widget.js